import pick from 'lodash/pick'
import D2C_ServiceWeb from './Web'

class D2C_ServiceHAProxy extends D2C_ServiceWeb {
  isEdge = true
  static objectType = 'serviceType'
  static active = true
  static order = 32
  static typeName = 'haproxy'
  static typeTitle = 'HAProxy'
  static color = '#3366aa'
  static fields = {
    ...D2C_ServiceWeb.fields,
    hosts: {
      ...D2C_ServiceWeb.fields.hosts,
      selector: {
        default: ['node'],
      },
    },
    image: {
      ...D2C_ServiceWeb.fields.image,
      default: 'haproxy',
    },
    ports: {
      ...D2C_ServiceWeb.fields.ports,
      default: [
        {protocol: 'TCP', value: 80},
        {protocol: 'TCP', value: 443},
      ],
    },
    remoteAccess: {
      ...D2C_ServiceWeb.fields.remoteAccess,
      default: true,
    },
    services: {
      default: [],
      label: 'Configure services',
      ownCertificates: false,
      path: 'services',
      required: false,
      serviceConfig: require('raw-loader!@/assets/configs/haproxy.tpl').default,
      serviceConfigFields: ['cert', 'config', 'domains', 'https', 'id', 'key', 'name', 'secure', 'sticky'],
      serviceConfigLimit: 1,
      serviceConfigSuffix: '-lb',
      serviceMethod: 'balance',
      servicePortProtocols: ['TCP'],
      serviceConfigModes: [
        {value: 'http', text: 'HTTP'},
        {value: 'https', text: 'HTTPS'},
        {value: 'tcp', text: 'TCP'},
      ],
      syntax: 'pug',
      validate(value) {
        return value.length ? null : 'You must add at least one service'
      },
      prepare(value) {
        return value.map(config => {
          return pick(config, ['cert', 'config', 'domains', 'https', 'id', 'key', 'name', 'secure', 'sticky'])
        })
      },
      creating: {},
      updating: {},
      updatingServices: {},
      importing: {
        hidden: true,
      },
    },
    version: {
      ...D2C_ServiceWeb.fields.version,
      default: 'latest',
      enum: ['latest'],
    },
    volumes: {
      ...D2C_ServiceWeb.fields.volumes,
      demo: [
        {src: '/etc/letsencrypt', dst: '/etc/letsencrypt', sync: false},
      ],
    },
  }
}

export default D2C_ServiceHAProxy
